
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 809 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#006a4e","d":"M0 0h809v500H0z"}}),_c('path',{attrs:{"fill":"#ffce00","d":"M0 100h809v100H0zM0 300h809v100H0z"}}),_c('path',{attrs:{"fill":"#d21034","d":"M0 0h300v300H0z"}}),_c('g',{attrs:{"transform":"translate(150 150)","fill":"#fff"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-95V0h50","transform":"rotate(18 0 -95)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(144)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(216)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(288)"}})])])
          )
        }
      }
    